<div class="menu row">
  <img src="assets/images/menu-icon.svg"/>
</div>

<div class="row" [routerLink]="CONSTANTS.ROUTES.MISSION_SELECTION" [routerLinkActive]="'selected'">
  <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4c1.93 0 5 1.4 5 5.15 0 2.16-1.72 4.67-5 7.32-3.28-2.65-5-5.17-5-7.32C7 5.4 10.07 4 12 4m0-2C8.73 2 5 4.46 5 9.15c0 3.12 2.33 6.41 7 9.85 4.67-3.44 7-6.73 7-9.85C19 4.46 15.27 2 12 2z"/><path d="M12 7c-1.1 0-2 .9-2 2s.9 2 2 2a2 2 0 1 0 0-4zM5 20h14v2H5v-2z"/></svg>
  <a>{{ 'MISSIONS.LABEL' | translate }}</a>
</div>

<div class="row" [routerLink]="CONSTANTS.ROUTES.CONTAINERS" [routerLinkActive]="'selected'">
  <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/></svg>
  <a>{{ 'CONTAINERS.LABEL' | translate }}</a>
</div>

<div class="row" [routerLink]="CONSTANTS.ROUTES.TEAMS"  [routerLinkActive]="'selected'">
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="48px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/></svg>
  <a>{{ 'TEAMS.LABEL' | translate }}</a>
</div>

<div class="row" [routerLink]="CONSTANTS.ROUTES.NEW_MISSION" [routerLinkActive]="'selected'">
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 5.25C10.5523 5.25 11 5.69772 11 6.25V9H13.75C14.3023 9 14.75 9.44771 14.75 10C14.75 10.5523 14.3023 11 13.75 11H11V13.75C11 14.3023 10.5523 14.75 10 14.75C9.44771 14.75 9 14.3023 9 13.75V11H6.25C5.69772 11 5.25 10.5523 5.25 10C5.25 9.44771 5.69772 9 6.25 9H9V6.25C9 5.69772 9.44771 5.25 10 5.25Z" fill="black" fill-opacity="0.7"/>
  </svg>
  <a>{{ 'NEW_MISSION.LABEL' | translate }}</a>
</div>

@if (!!amountOfAlerts) {
  <div class="row" [routerLink]="CONSTANTS.ROUTES.ALERTS_VIEW" [routerLinkActive]="'selected'">
    <img src="assets/images/alert-button.svg"/>
    <a class="alerts">{{ amountOfAlerts }}</a>
  </div>
}

<div class="footer">
  <div class="row" (click)="logout()">
    <svg viewBox="0 0 24 24" id="logout"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 3H13V13H11V3ZM16.41 6.59L17.83 5.17C19.77 6.82 21 9.26 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 9.26 4.23 6.82 6.17 5.17L7.58 6.58C6.01 7.86 5 9.81 5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 9.81 17.99 7.86 16.41 6.59Z"></path></svg>
    <a>{{ 'LOGOUT' | translate }}</a>
  </div>

  <img class="logo" src="assets/images/arkema-logo.png"/>
</div>
